import { createSlice } from "@reduxjs/toolkit";
import { ITechnologyResourceSlice } from "../../../models/master/technologyResource";


const initialtechnologyResourceState: ITechnologyResourceSlice = {
  technologyResources:undefined,
  technologyResource:undefined
};

const technologyResourceSlice = createSlice({
  name: "technologyResource",
  initialState: initialtechnologyResourceState,
  reducers: {  
    setTechnologyResources: (state, action: { payload: any }) => {
      state.technologyResources = action.payload;
    },
    setTechnologyResource: (state, action: { payload: any }) => {
      state.technologyResource = action.payload;
    },
    
  },
});

export const { setTechnologyResources, setTechnologyResource } =
technologyResourceSlice.actions;

const technologyResourceReducer = technologyResourceSlice.reducer;

export type technologyResourceState = ReturnType<typeof technologyResourceReducer>;

export default technologyResourceReducer;
